module.exports = __webpack_public_path__ + "media/BatimentArtisanatArt.438d1018.mp3";